<template>
  <div class="c-list__content">
    <h2 class="c-list__title">
      <a 
        v-bind:href="siteUrl + item.url" 
        class="c-list__link"
        v-on:click="searchResultsClick">{{item.title}}</a>
    </h2>
    <div class="c-list__body" v-html="item.body"></div>
    <dl class="c-list__meta" v-if="validDate">
      <dt class="c-list__meta-title">Publication Date</dt>
      <dd class="c-list__meta-detail"><time v-bind:datetime="item.publicationDate">{{item.publicationDate | formatDate}}</time></dd>
    </dl>
  </div>
</template>

<script>
import moment from "NodeModules/moment/moment";

export default {
  name: "SearchItemPage",
  props: {
    item: {
      type: Object
    },
     siteUrl: {
      type: String,
    },
  },
  computed: {
    validDate: function () {
      return moment(this.item.publicationDate).isAfter('1900-01-01', 'year');
    },
  },
  methods: {
    searchResultsClick() {
      this.$emit('resultClick', "pages", this.item.objectId, this.item.position);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/components/developers/results/SearchItemPage.vue